/* Ovetto — comportamiento de la landing. Sin dependencias. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      /* almacenamiento bloqueado: seguimos sin él */
    }
  }

  function slug(texto) {
    return String(texto || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* ---------- Header: sombra al hacer scroll ---------- */

  function initHeader() {
    var header = document.querySelector('[data-ovetto-header]');
    if (!header) return;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Contador de días (America/Santiago vía offset en la fecha) ---------- */

  function initContadores() {
    document.querySelectorAll('[data-ovetto-contador]').forEach(function (el) {
      var objetivo = Date.parse(el.getAttribute('data-ovetto-contador'));
      if (isNaN(objetivo)) return;
      var numero = el.querySelector('[data-contador-numero]');
      var texto = el.querySelector('[data-contador-texto]');
      var listo = el.getAttribute('data-listo') || '';

      var render = function () {
        var dias = Math.ceil((objetivo - Date.now()) / 86400000);
        if (dias > 0) {
          numero.textContent = String(dias);
          if (texto) texto.hidden = false;
          el.classList.remove('is-listo');
        } else {
          numero.textContent = listo;
          if (texto) texto.hidden = true;
          el.classList.add('is-listo');
        }
      };
      render();
      window.setInterval(render, 60000);
    });
  }

  /* ---------- Video: carga al acercarse, respeta "reducir movimiento" ---------- */

  function initVideos() {
    var videos = document.querySelectorAll('.o-telefono video');
    if (!videos.length) return;

    var escritorio = window.matchMedia('(min-width: 768px)').matches;

    var arrancar = function (video) {
      var src = (escritorio && video.getAttribute('data-src-escritorio')) || video.getAttribute('data-src');
      if (src && !video.getAttribute('src')) video.setAttribute('src', src);
      video.muted = true;
      var p = video.play && video.play();
      if (p && p.catch) p.catch(function () {});
    };

    videos.forEach(function (video) {
      video.muted = true;
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        arrancar(video);
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              arrancar(video);
              io.disconnect();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
      io.observe(video);
    });
  }

  /* ---------- Preguntas: acordeón en móvil, abiertas en escritorio ---------- */

  function initFaq() {
    var listas = document.querySelectorAll('[data-ovetto-faq]');
    if (!listas.length) return;
    var mq = window.matchMedia('(min-width: 768px)');
    var aplicar = function () {
      listas.forEach(function (lista) {
        lista.querySelectorAll('details').forEach(function (d) {
          d.open = mq.matches;
        });
      });
    };
    aplicar();
    if (mq.addEventListener) mq.addEventListener('change', aplicar);

    listas.forEach(function (lista) {
      lista.addEventListener('click', function (e) {
        if (mq.matches && e.target.closest('summary')) e.preventDefault();
      });
    });
  }

  /* ---------- Enlaces pendientes (Instagram sin configurar) ---------- */

  function initPendientes() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-pendiente]');
      if (link) e.preventDefault();
    });
  }

  /* ---------- UTMs: se guardan al llegar para mandarlas con el formulario ---------- */

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function capturarUtms() {
    var params = new URLSearchParams(window.location.search);
    var tiene = UTM_KEYS.some(function (k) {
      return params.get(k);
    });
    if (!tiene) return;
    var data = {};
    UTM_KEYS.forEach(function (k) {
      if (params.get(k)) data[k] = params.get(k).slice(0, 100);
    });
    storageSet('ovetto_utm', JSON.stringify(data));
  }

  function leerUtms() {
    var raw = storageGet('ovetto_utm');
    if (!raw) return {};
    try {
      return JSON.parse(raw) || {};
    } catch (e) {
      return {};
    }
  }

  /* ---------- Formulario lista de espera ---------- */

  // Acepta +56 9 XXXX XXXX, 569XXXXXXXX, 9XXXXXXXX o los 8 dígitos tras el "+56 9".
  function normalizarCelular(valor) {
    var d = String(valor || '').replace(/\D/g, '');
    if (d.length === 11 && d.indexOf('569') === 0) return '+' + d;
    if (d.length === 9 && d.charAt(0) === '9') return '+56' + d;
    if (d.length === 8) return '+569' + d;
    return null;
  }

  function marcarError(form, campo, hayError) {
    var wrap = form.querySelector('[data-campo="' + campo + '"]');
    if (!wrap) return;
    wrap.classList.toggle('is-error', hayError);
    wrap.querySelectorAll('input, select').forEach(function (input) {
      if (hayError) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    });
  }

  function validar(form) {
    var errores = [];
    var nombre = form.elements.nombre.value.trim();
    var celular = normalizarCelular(form.elements.whatsapp.value);
    var comuna = form.elements.comuna.value;
    var tipoInput = form.querySelector('input[name="tipo"]:checked');
    var consumo = form.elements.consumo.value;
    var ok = form.elements.consentimiento.checked;

    var checks = [
      ['nombre', nombre.length >= 2],
      ['whatsapp', !!celular],
      ['comuna', !!comuna],
      ['tipo', !!tipoInput],
      ['consumo', !!consumo],
      ['consentimiento', ok],
    ];
    checks.forEach(function (c) {
      marcarError(form, c[0], !c[1]);
      if (!c[1]) errores.push(c[0]);
    });

    return {
      errores: errores,
      datos: {
        nombre: nombre,
        whatsapp: celular,
        comuna: comuna,
        tipo: tipoInput ? tipoInput.value : '',
        consumo: consumo,
      },
    };
  }

  function enfocarPrimerError(form, campo) {
    var wrap = form.querySelector('[data-campo="' + campo + '"]');
    var input = wrap && wrap.querySelector('input, select');
    if (input) input.focus();
  }

  function publicarLead(datos, utms, metodo) {
    var evento = {
      content_category: datos.tipo || '',
      comuna: datos.comuna || '',
      consumo: datos.consumo || '',
      origen: utms.utm_source || 'directo',
      metodo: metodo || 'formulario',
    };
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('ovetto_lead', evento);
      }
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_category: evento.content_category });
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', evento);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'generate_lead' }, evento));
    } catch (e) {}
  }

  function mostrarExito(contenedor, variante) {
    var exito = contenedor.querySelector('[data-ovetto-exito]');
    contenedor.querySelectorAll('[data-ovetto-form], [data-ovetto-form-app]').forEach(function (el) {
      el.hidden = true;
    });
    if (!exito) return;
    if (variante === 'whatsapp') {
      var normal = exito.querySelector('[data-exito-texto]');
      var alterno = exito.querySelector('[data-exito-texto-whatsapp]');
      if (normal && alterno) {
        normal.hidden = true;
        alterno.hidden = false;
      }
    }
    exito.hidden = false;
    var titulo = exito.querySelector('[data-exito-titulo]');
    if (titulo) titulo.focus({ preventScroll: true });
    exito.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  }

  function initFormularios() {
    var forms = document.querySelectorAll('[data-ovetto-form]');
    if (!forms.length) return;

    // Botones de "Dos caminos": preseleccionan Casa o Negocio
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ovetto-tipo]');
      if (!link) return;
      var tipo = link.getAttribute('data-ovetto-tipo');
      forms.forEach(function (form) {
        var radio = form.querySelector('input[name="tipo"][value="' + tipo + '"]');
        if (radio) {
          radio.checked = true;
          marcarError(form, 'tipo', false);
        }
      });
    });

    forms.forEach(function (form) {
      var estado = form.querySelector('[data-form-estado]');
      var boton = form.querySelector('button[type="submit"]');
      var endpoint = form.getAttribute('data-endpoint');

      // Al corregir un campo se limpia su error
      form.addEventListener('change', function (e) {
        var wrap = e.target.closest('[data-campo]');
        if (wrap && wrap.classList.contains('is-error')) validar(form);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        estado.textContent = '';

        var resultado = validar(form);
        if (resultado.errores.length) {
          enfocarPrimerError(form, resultado.errores[0]);
          return;
        }

        // Trampa para bots: responde como si nada
        if (form.elements.web && form.elements.web.value) {
          mostrarExito(form.parentNode);
          return;
        }

        var datos = resultado.datos;
        var utms = leerUtms();
        var tags = [
          'lista-espera',
          'tipo-' + datos.tipo,
          'comuna-' + slug(datos.comuna),
          'consumo-' + slug(datos.consumo),
          'origen-' + slug(utms.utm_source || 'directo'),
        ];

        var payload = new URLSearchParams();
        payload.append('nombre', datos.nombre);
        payload.append('whatsapp', datos.whatsapp);
        payload.append('comuna', datos.comuna);
        payload.append('tipo', datos.tipo);
        payload.append('consumo', datos.consumo);
        payload.append('consentimiento', 'si');
        payload.append('consentimiento_texto', form.querySelector('label[for="' + form.elements.consentimiento.id + '"]').textContent.trim());
        payload.append('tags', tags.join(','));
        UTM_KEYS.forEach(function (k) {
          payload.append(k, utms[k] || '');
        });
        payload.append('pagina', window.location.origin + window.location.pathname);
        payload.append('fecha', new Date().toISOString());

        if (form.getAttribute('data-modo') === 'whatsapp') {
          var tipoTexto = datos.tipo === 'negocio' ? 'mi negocio' : 'mi casa';
          var mensaje = [
            'Hola Ovetto, quiero reservar mi lugar en la lista.',
            'Nombre: ' + datos.nombre,
            'WhatsApp: ' + datos.whatsapp,
            'Comuna: ' + datos.comuna,
            'Es para: ' + tipoTexto,
            'Consumo semanal: ' + datos.consumo + ' huevos',
            'Acepto que Ovetto me escriba por WhatsApp sobre el inicio de producción.',
          ].join('\n');
          var url = 'https://wa.me/' + form.getAttribute('data-whatsapp') + '?text=' + encodeURIComponent(mensaje);
          var ventana = window.open(url, '_blank');
          if (ventana) {
            ventana.opener = null;
          } else {
            window.location.href = url;
          }
          publicarLead(datos, utms, 'whatsapp');
          mostrarExito(form.parentNode, 'whatsapp');
          return;
        }

        if (!endpoint) {
          // Vista previa: no se envía nada
          if (window.console) window.console.info('[Ovetto] Vista previa, no se guardó:', Object.fromEntries(payload));
          mostrarExito(form.parentNode);
          return;
        }

        boton.disabled = true;
        fetch(endpoint, { method: 'POST', mode: 'no-cors', body: payload })
          .then(function () {
            publicarLead(datos, utms);
            mostrarExito(form.parentNode);
          })
          .catch(function () {
            estado.textContent = 'No pudimos guardar tus datos. Inténtalo de nuevo o escríbenos por WhatsApp.';
            boton.disabled = false;
          });
      });
    });
  }

  /* ---------- Regreso desde Shopify Forms: /?lista=ok#lista ---------- */

  function initRegresoLista() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('lista') !== 'ok') return;
    var contenedor = document.querySelector('[data-ovetto-lista]');
    if (!contenedor) return;
    mostrarExito(contenedor);
    publicarLead({}, leerUtms(), 'shopify-forms');
    // Quita el parámetro para que recargar no repita el evento
    params.delete('lista');
    var query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
  }

  function init() {
    capturarUtms();
    initHeader();
    initContadores();
    initVideos();
    initFaq();
    initPendientes();
    initFormularios();
    initRegresoLista();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
